var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11387_68360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9875 15.5471C9.80951 15.547 9.63496 15.5046 9.48278 15.4246L6.23427 13.7357C5.86877 13.5447 5.56622 13.2752 5.35579 12.9534C5.14536 12.6315 5.03415 12.2681 5.03288 11.8982V8.07709C5.03351 7.80741 4.93675 7.54432 4.75617 7.32469L0.220524 1.80034C0.114614 1.67281 0.0514138 1.5224 0.0378959 1.3657C0.0243779 1.20901 0.0610681 1.05213 0.143918 0.912367C0.226768 0.772604 0.352557 0.655393 0.507406 0.573667C0.662256 0.491941 0.840145 0.448877 1.02145 0.449226H14.984C15.1655 0.448571 15.3436 0.491447 15.4986 0.573108C15.6537 0.654769 15.7797 0.772028 15.8626 0.911904C15.9455 1.05178 15.9821 1.20881 15.9684 1.36562C15.9547 1.52242 15.8912 1.67288 15.7849 1.80034L11.2493 7.32469C11.0684 7.54422 10.9713 7.80732 10.9716 8.07709V14.6925C10.9713 14.9188 10.8676 15.1357 10.6832 15.2959C10.4988 15.4561 10.2486 15.5464 9.9875 15.5471ZM1.02145 1.29789L5.54929 6.83492C5.84937 7.19672 6.00967 7.63153 6.00724 8.07709V11.8974C6.0076 12.1215 6.0748 12.3418 6.20233 12.5368C6.32986 12.7318 6.51338 12.8949 6.73509 13.0103L9.9836 14.6992L9.99724 8.07625C9.9951 7.63059 10.1557 7.19577 10.4562 6.83407L14.9908 1.30972L1.02145 1.29789Z",
    fill: "#2D6CDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11387_68360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterActive);
export default __webpack_public_path__ + "static/media/filter-active.279e36f81d86b3c0ff2654d52fe9de02.svg";
export { ForwardRef as ReactComponent };